import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';

import { cabinetTheme } from './theme/cabinetTheme';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter basename="/cabinet">
    <MantineProvider theme={cabinetTheme}>
      <Notifications position="top-right" />
      <App />
    </MantineProvider>
  </BrowserRouter>
);
